import { render, staticRenderFns } from "./copyAd.vue?vue&type=template&id=16b91f2b&scoped=true"
import script from "./copyAd.vue?vue&type=script&lang=js"
export * from "./copyAd.vue?vue&type=script&lang=js"
import style0 from "./copyAd.vue?vue&type=style&index=0&id=16b91f2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b91f2b",
  null
  
)

export default component.exports